import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from '../../components/Link';
import moment from 'moment';

import RelativeTime from '../RelativeTime';

import css from '../../styles/notices/notice';

moment.locale('sv');

class Notice extends Component {
    static propTypes = {
        showSymbol: PropTypes.bool,
        COMPANY_TICKER: PropTypes.string,
        ITEM_SECTOR: PropTypes.string,
        LONG_NAME: PropTypes.string,
        HEADLINE: PropTypes.string,
        NEWSTYPE: PropTypes.string,
        REFERENCEID: PropTypes.string,
        TEXT: PropTypes.string,
        TIME: PropTypes.number,
    }

    constructor(props) {
        super(props);

        this.state = { expanded: false };

        this._toggleClamp = () => this.setState({ expanded: !this.state.expanded });

        this._stopPropagation = e => e.stopPropagation();
    }

    renderTitle() {
        const { ITEM_SECTOR, LONG_NAME, HEADLINE, showSymbol } = this.props;

        let symbol;

        if (showSymbol && LONG_NAME) {
            symbol = (
                <span><Link
                    className={css.link}
                    onClick={this._stopPropagation}
                    to={`/instrument/${ITEM_SECTOR}`}
                >
                    {LONG_NAME}
                </Link> · </span>
            );
        }

        return (
            <span className={css.emphasize}>{symbol}{HEADLINE}</span>
        );
    }

    renderText() {
        const { TEXT } = this.props;

        return TEXT ? TEXT.replace(/<{1}[^<>]{1,}>{1}/g, ' ').trim() : '-';
    }

    renderNewstype() {
        const { NEWSTYPE } = this.props;

        return NEWSTYPE.slice(0, 1) + NEWSTYPE.substring(1, NEWSTYPE.length).toLowerCase();
    }

    render() {
        const clampClass = this.state.expanded
            ? css.expanded : css.clamped;

        return (
            <div className={css.container} onClick={() => this._toggleClamp()}>
                <div>
                    <div className={clampClass}>
                        {this.renderTitle()}
                    </div>
                    <div className={clampClass}>
                        <span>{this.renderText()}</span>
                    </div>
                </div>
                <div className={css.footer}>
                    <span>
                        {this.renderNewstype()} · <RelativeTime date={this.props.TIME} />
                    </span>
                </div>
            </div>
        );
    }

}

export default Notice;



/** WEBPACK FOOTER **
 ** /src/shared/components/notices/Notice.js
 **/